export interface Gtm {
  containerId: string;
  isInitialized: boolean;
  gtmTagSteps: Array<string>;
};

export const initialState: Gtm = {
  containerId: '',
  isInitialized: false,
  gtmTagSteps: [],
};

export type GtmState = Readonly<Gtm>;